import { fetchApi } from '@/config/axiosSetting';
import { VisitInformationTypeParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';
import { VisitOtherInformationResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitOtherDamagedInformation/getVisitOtherDamagedInformationQuer.type';

export const getVisitOtherInformationQueryFunction = (
  params: VisitInformationTypeParams,
): Promise<VisitOtherInformationResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/other_damaged/adjusting/visit_information/`,
    {
      params: {
        id: params.id,
        damaged_id: params.damaged_id,
        source: params.source,
      },
    },
  );
};
